module.exports = __webpack_public_path__ + "img/nameless hill.ed715cc4.png";